import { Component, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { CMSService } from '../../../services/cms-service';

@Component({
  selector: 'app-article2',
  templateUrl: './article2.component.html',
  styleUrls: ['./article2.component.scss']
})
export class Article2Component implements OnInit {

   urllogoIec = environment.urllogoIec;
   statistique_actu : any = "alerte_corona.PNG";
   liste_apropos:any;

  constructor(private router: Router, public cmsService: CMSService) { }

  ngOnInit() {
  }

  article1(id:any){
    if(id==1){
      //corona Virus
      this.router.navigate(['landing']);
    }else if(id==2){
      //LE VOCABULAIRE DU DIABETE
      this.router.navigate(['article2']);
    }else if(id==3){
      //LE DIABETE GESTATIONNEL
      this.router.navigate(['article3']);
    }else if(id==11){
      //APPRENEZ A VIVRE AVEC LE DIABETE
      this.router.navigate(['article']);
    }

  
  }

  getinfoIec(){
    this.router.navigate(['iec']);
   }

}
